var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("path",{"d":"M8,15a7,7,0,1,1,7-7A7,7,0,0,1,8,15ZM8,3a5,5,0,1,0,5,5A5,5,0,0,0,8,3Z","key":1}),React.createElement("rect",{"x":"14","y":"12","width":"2","height":"6","transform":"translate(-6.21 15) rotate(-45)","key":2})]);
}

Search.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Search;

Search.default = Search;
